import "./pill-radio-input.scss";

import React from "react";
import classNames from "classnames";
import { isArray } from "lodash";

type optionType = {
  label: string;
  value: string;
};

export interface PillRadioProps {
  isReadonly?: boolean;
  isRequired?: boolean;
  label?: string;
  name?: string;
  onChange: (value: string | string[], name: string | undefined) => void;
  options: optionType[];
  value: string | string[];
}

const PillRadioInput = (props: PillRadioProps) => {
  const { options = [], name, value, onChange, label, isRequired, isReadonly } = props || {};

  return (
    <div className="hmf-pills-container">
      {label && (
        <label
          className={classNames("inp-label", {
            "inp-label--required": isRequired,
          })}
        >
          {label}
        </label>
      )}
      <div className="hmf-select-options">
        {options.map((item, index) => {
          // if the role only exists in local
          // support array checking
          const selected = value;
          const isSelected = isArray(selected)
            ? selected?.includes(item?.value)
            : selected === item?.value;

          return (
            <span
              className={classNames("rmf-option", {
                selected: isSelected,
                "read-only": isReadonly,
              })}
              onClick={() => !isReadonly && onChange(item?.value, name)}
              key={index}
            >
              {item?.label}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default PillRadioInput;
